export * from './storage-place.routes';
export * from './container/container.component';



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/storage-place/index.ts